import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('employee_hod_mapping')

export class EmployyeHodMapping{

    @PrimaryGeneratedColumn("increment",{
        name:"id"
    })
    id:number;

    @Column('int',{
        name: 'employee_id',
        nullable: false
    })
    employeeId: number;

    @Column('int',{
        name: 'hod_id',
        nullable: false
    })
    hodId: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active",
      })
      isActive: boolean;
      
    @Column("varchar", {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

}



